// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2T4QY","content":"LayoutSettings_content__Yz7fx"};